module.exports = __webpack_public_path__ + "static/DJSimulator-b4d44268af00bb2863ac43f8e7c0cfd0.gif";